import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    defaultIndicator: {
      fontStyle: 'italic',
      color: theme.palette.text.disabled,
    },
    percentageCell: {
      width: '120px',
    },
    customDataCell: {
      width: '0px',
      minWidth: 'fit-content',
    },
    customDataButton: { whiteSpace: 'nowrap' },
    deleteCell: {
      width: '40px',
    },
    totalCell: {
      fontWeight: 'bold',
    },
    percentageTotalCell: {
      fontWeight: 'bold',
      textAlign: 'right',
    },
    errorCell: {
      fontWeight: 'bold',
      color: theme.palette.error.main,
    },
  };
};
